import Marquee from "react-fast-marquee";

const ITEMS = [
  "Atelier Edit · New Arrivals",
  "Complimentary Shipping over ₹3,500",
  "7-Day Atelier Replacement",
  "Made in India · Worn Worldwide",
  "Hand-Finished. Heritage Cut.",
];

export default function OfferTicker() {
  return (
    <div className="bg-foreground text-background border-b border-border" data-testid="offer-ticker">
      <Marquee speed={28} gradient={false} pauseOnHover>
        <div className="flex items-center gap-12 py-2.5 pr-12">
          {ITEMS.concat(ITEMS).map((t, i) => (
            <span key={i} className="ie-overline whitespace-nowrap opacity-90">
              {t}
              <span className="ml-12 opacity-40">/</span>
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
